import { render, staticRenderFns } from "./SampleFeesPreview.vue?vue&type=template&id=616bcff8&scoped=true&"
import script from "./SampleFeesPreview.vue?vue&type=script&lang=ts&"
export * from "./SampleFeesPreview.vue?vue&type=script&lang=ts&"
import style0 from "./SampleFeesPreview.vue?vue&type=style&index=0&id=616bcff8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616bcff8",
  null
  
)

export default component.exports